(function() {
  
  angular.module('OnDeviceConfigProvider', [])
  
  .factory('OnDeviceConfigModel', ['$q', '$http', 'PrinterModel', 'Utils',
    function($q, $http, PrinterModel, Utils) {
    return function(data) {
      var OnDeviceConfigModel = {
        info: data,
        name: data.name,
        links: data._links,
        id: extractId(data._links.self.href)
      };

      function extractId (selfLink) {
        var id = selfLink.split('/');
        id = id[id.length -1];
        return id;
      }

      OnDeviceConfigModel.getPrinters = function (pageParams, embedPrinterStatus) {
        var deferred = $q.defer();
        var params = '&' + pageParams.getPagedUrlParameters();
        var url = OnDeviceConfigModel.info._links['px:printers'].href + params;

        if (embedPrinterStatus) {
          url = url + '&embed=status,latestOnDeviceVersion,latestCaptureVersion';
        }

        $http.get(url).then(function(response) {
          var pageObject = {
            page: response.data.page,
            list: []
          }
          if (response.data._embedded) {
            pageObject.list = response.data._embedded['px:printerResources'];
            for (var i = 0; i < pageObject.list.length; i++) {
              pageObject.list[i] = new PrinterModel(pageObject.list[i]);
            }
          }
          deferred.resolve(pageObject);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      OnDeviceConfigModel.updateOnDeviceConfig = function (onDeviceConfig) {
        var deferred = $q.defer()


        var whitelist = [
          '/accessCopy', 
          '/accessEmail', 
          '/accessEverythingElse', 
          '/accessFax', 
          '/accessScan', 
          '/accessUsbPrint',
          '/accessUsbScan',
          '/description',
          '/emailSender',
          '/name',
          '/signin',
          '/installCaptureApp'
        ]
        
        var url = OnDeviceConfigModel.info._links.self.href;
        var patchArray = Utils.getObjectsDifferencesForPatching(OnDeviceConfigModel.info, onDeviceConfig);
        for (var i = 0; i < patchArray.length; i++) {

          if (whitelist.indexOf(patchArray[i].path) < 0) {
            
            patchArray.splice(i, 1);
            i = i - 1;
          }
        }


        if (patchArray.length > 0) {
          patchArray.forEach((patch) => {
            if (patch.path === '/emailSender' && !patch.value) {
              patch.op = 'remove'
            }
          })
          $http.patch(url, patchArray).then(function(response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
        } else {
          deferred.reject();
        }
        return deferred.promise;
      }

      OnDeviceConfigModel.updatePrintersDeviceConfig = function () {
        var deferred = $q.defer()
        var url = OnDeviceConfigModel.info._links['px:configUpdateAll'].href;
        $http.post(url).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }


      OnDeviceConfigModel.uninstallPrintersDeviceConfig = function () {
        var deferred = $q.defer()
        var url = OnDeviceConfigModel.info._links['px:configUninstallFromPrinters'].href;
        $http.post(url).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      return OnDeviceConfigModel;
    }
  }])

  .factory('OnDeviceConfigPaging',
  ['DEFAULT_ITEMS_PER_PAGE', 
  function(DEFAULT_ITEMS_PER_PAGE) {
    return function () {
      var OnDeviceConfigPaging = {};

      OnDeviceConfigPaging.pagingCriteria = {
        page: 0,
        pageSize: DEFAULT_ITEMS_PER_PAGE,
        direction: "ASC",
        sort: 'NAME',
        match: null,
      }

      OnDeviceConfigPaging.getPagedUrlParameters = function() {
        var urlParameters =
          '?page=' + OnDeviceConfigPaging.pagingCriteria.page +
          "&pageSize=" + OnDeviceConfigPaging.pagingCriteria.pageSize +
          "&direction=" + OnDeviceConfigPaging.pagingCriteria.direction +
          "&sort=" + OnDeviceConfigPaging.pagingCriteria.sort;
        
        if (OnDeviceConfigPaging.pagingCriteria.match) {
          urlParameters += "&match=" + OnDeviceConfigPaging.pagingCriteria.match;
        }

        return urlParameters;
      }
      return OnDeviceConfigPaging;
    }
  }])

  .service('OnDeviceConfigService', ['$http', '$q', 'TenantListService', 'OnDeviceConfigModel',
    function($http, $q, TenantListService, OnDeviceConfigModel) {
      
      var tenant = TenantListService.currentTenant;

      this.getOnDeviceConfigsList = function (onDeviceConfigPaging) {
        var deferred = $q.defer()
        var url = tenant.info._links['px:onDeviceConfigs'].href;
        $http.get(url + onDeviceConfigPaging.getPagedUrlParameters()).then(function(response) {
          var listObject = {
            page: response.data.page,
            _links: response.data._links,
            list: []};
            
          if (response.data._embedded) {
            angular.forEach(response.data._embedded['px:onDeviceConfigResources'], function(onDeviceConfig) {
              listObject.list.add(new OnDeviceConfigModel(onDeviceConfig));
            });
          }
          deferred.resolve(listObject);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;

      }

      this.createOnDeviceConfig = function (config) {
        var deferred = $q.defer()
        var url = tenant.info._links['px:onDeviceConfigs'].href;
        $http.post(url, config).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      this.getOnDeviceConfigByUrl = function (url) {
        var deferred = $q.defer()
        $http.get(url).then(function(response) {
          var onDeviceConfig = new OnDeviceConfigModel(response.data);
          deferred.resolve(onDeviceConfig);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }
      
    }
  ])  

})();